/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import abstractContractClaimTranslations from "./abstractContractClaimTranslations";

const serviceContractTranslations = {
  label: "Dienstleistungsvertrag",
  reasonForDispute: {
    label: "Problem mit Vertrag",
    question: "Welches Problem gibt es mit dem Handwerker / der Dienstleistung?",
    options: {
      costEstimateExceeded: { label: "Die Rechnung ist höher als der Kostenvoranschlag" },
      unfinishedWork: { label: "Die Leistung wurde nicht vollständig erbracht" },
      hasDefects: { label: "Die Leistung war fehlerhaft / weist Mängel auf" },
      other: { label: "Es gibt ein anderes Problem" },
    },
  },
  serviceTitle: {
    label: "Beschreibung der Dienstleistung",
  },
  costEstimate: {
    label: "Kostenvoranschlag",
    question: "Wie hoch war der Kostenvoranschlag?",
  },
  costEstimateAdjustment: {
    label: "Information über Erhöhung",
    question: "Wie hat Sie der Vertragspartner über die Kostenerhöhung informiert?",
    options: {
      asap: { label: "Ich wurde umgehend über die Kostenerhöhung informiert" },
      tooLate: { label: "Ich wurde zu spät über die Kostenerhöhung informiert" },
      notAtAll: { label: "Ich wurde gar nicht über die Kostenerhöhung informiert" },
    },
  },
  costEstimateAdjustmentDate: {
    label: "Datum Information Erhöhung",
  },
  costReal: {
    label: "Rechnungsbetrag",
    question: "Wie hoch war die Rechnung?",
  },
  defectsDescriptionClient: {
    label: "Beschreibung Mängel",
  },
  numberRepairAttempts: {
    label: "Ausbesserungsversuche",
    options: {
      0: { label: "Nein" },
      1: { label: "Ja, einmal" },
      2: { label: "Ja, zweimal" },
      3: { label: "Ja, dreimal oder häufiger" },
    },
  },
  ...abstractContractClaimTranslations,
};

export default serviceContractTranslations;
